<template>
  <v-container fluid class="px-0">
    <div class="payment-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" md="12">
                  <v-row>
                    <v-col md="11">
                      <p class="text-h5">Payment {{ initvalue.paymentnum }}</p>
                    </v-col>
                    <v-col md="1" align="right">
                      <v-btn
                      class="button-shadow"
                      color="primary"
                     @click="Done"
                      >
                        Done
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="no-gutters" style="margin-left: 15px;">
                <v-col cols="12" md="10">
                  <v-row>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Num:</span></td>
                          <td>{{ initvalue.paymentnum }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Date:</span></td>
                          <td>{{ new Date(initvalue.paymentdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Name:</span></td>
                          <td>{{ initvalue.paymentname }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Payment From:</span></td>
                          <td>
                            <p class="two-line">
                                {{ accounts.length>0 ? accounts.find(account=>account._id == initvalue.accountid)['accountnum'] : '' }}
                                :
                                {{ accounts.length>0 ? accounts.find(account=>account._id == initvalue.accountid)['accountname'] : '' }}
                              </p>
                          </td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Ref Num:</span></td>
                          <td>{{ initvalue.refnum }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">

                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-items'"
                    >
                      Items
                    </v-tab>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-files'"
                    >
                      Files
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-images'"
                    >
                      Images
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-items'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            :loading="isReceiving"
                            loading-text="Loading... Please wait"
                            item-key="_id"
                            sort-by="transdate"
                            :footer-props="footer"
                            :headers="itemHeaders2"
                            :items="transactions"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.itemimage="{ item }">
                              <v-img
                              v-if="item.itemimage" 
                              v-bind:src="item.itemimage"
                              max-height="100"
                              max-width="100"
                            ></v-img>
                            </template>
                            <template v-slot:item.accountid="{ item }">
                              <p class="two-line">
                                {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountnum'] : '' }}
                                :
                                {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                              </p>
                            </template>
                            <template v-slot:item.transdate="{ item }">
                              {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                            </template>
                            <template v-slot:item.itemamount="{ item }">
                              <p class="two-line">{{ item.itemamount.toFixed(2) }}</p>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item :value="'tab-files'" :key="2">
                      <FileView :id="initvalue._id" :route="`payment`" :files="files" :data="initvalue"/>
                    </v-tab-item>   
                    <v-tab-item
                      :key="3"
                      :value="'tab-images'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-container
                        class="fill-height"
                        fluid
                        style="min-height: 434px"
                      >
                        <v-fade-transition mode="out-in">
                          <v-row>
                            <v-col cols="4">
                              <v-card
                              v-for="image in images" :key="image._id"
                              :ripple="{class: 'ripple-color' }"
                              @click="clickImage(image)"
                              >
                                <v-img
                                  :src="image.imageurl"
                                  height="300"
                                  cover
                                  class="bg-grey-lighten-4"
                                  
                                ></v-img>
                                <v-card-title class="text-h8">
                                  {{ image.imagename }}
                                </v-card-title>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-fade-transition>
                      </v-container>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div class="text-center">
    <v-dialog
      v-model="showImageDialog"
      width="500px"
    >
      <v-card class="mx-1 mb-1">
        <v-card-text>
          
          <v-row v-if="image">
            <v-col cols="12">
              <v-img
              max-width="500px"
              cover
              :src="image.imageurl"
            ></v-img> 
            </v-col>

          </v-row>
      
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="showImageDialog = false"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "@/config";
import { mapState, mapActions } from 'vuex';
import FileView from "@/pages/File/Components/FileView.vue";

export default {
  name: "PaymentView",
  components: {
    FileView
  },
  data() {
    return {
      config,
      initvalue: {},
      transactions: [],
      files: [],
      images: [],
      selectedTab: "1",
      showImageDialog: false,
      image: null,
      itemHeaders1: [
        { text: 'Image', value: 'itemimage' },
        { text: 'Name', value: 'itemname' },
        { text: 'Foc', value: 'itemfoc' },
        { text: 'Qty', value: 'itemquantity', width: '10%'},
        { text: 'Prc', value: 'itemprice', width: '10%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
      ],
      itemHeaders2: [
      { text: 'Date', value: 'transdate' },  
      { text: 'Account', value: 'accountid' },
        { text: 'Description', value: 'itemdesc', width: '30%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
      ],
      fileHeaders: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Payment', ['isReceiving']),
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions("Payment", ["getPaymentRequest"]),
    clickImage(image){
      console.log(image.imageurl);
      this.image = image;
      this.showImageDialog = true;
    },
    previewFile(item){
      let params = Object.assign({}, this.initvalue);
      params.fileurl = item.fileurl;
      params.isFromPayment = true;
      this.$router.push({ name: "FilePreview", params: params })
    },
    Done(){
      this.$router.push({ name: 'PaymentList' });
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "PaymentList" });

    let result = await this.getPaymentRequest(this.initvalue._id);
    this.transactions = Object.assign([], result.transactions);
    this.files = Object.assign([], result.files);
    this.images = Object.assign([], result.images);

    if(this.accounts.length==0) await this.getAccountsRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
